import React from "react";
import Login from "../pages/Login/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import Products from "../pages/Products/Products";
import AddProduct from "../pages/Products/AddProduct";
import ProductEditor from "../pages/Products/ProductEditor";
import Orders from "../pages/Orders/Orders";
import Customers from "../pages/Customers/Customers";
import Coupons from "../pages/Coupons/Coupons";
import Categories from "../pages/Categories/Categories";
import SubCategories from "../pages/SubCategories/SubCategories";
import PageEditor from "../pages/CMS/PageEditor";
import ContactCMS from "../pages/CMS/ContactCMS";
import Banners from "../pages/Banners/Banners";
import FAQ from "../pages/FAQ/FAQ";
import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../components/ProtectedRoute";

export default function Router(){
    return(
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
          <Route path="/products/add" element={<ProtectedRoute><AddProduct /></ProtectedRoute>} />
          <Route path="/products/edit/:id" element={<ProtectedRoute><ProductEditor /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
          <Route path="/banners" element={<ProtectedRoute><Banners /></ProtectedRoute>} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/categories" element={<ProtectedRoute><Categories /></ProtectedRoute>} />
          <Route path="/sub-categories" element={<ProtectedRoute><SubCategories /></ProtectedRoute>} />
          <Route path="/coupons" element={<ProtectedRoute><Coupons /></ProtectedRoute>} />
          <Route path="/faqs" element={<ProtectedRoute><FAQ /></ProtectedRoute>} />
          {/* Individual Content Pages */}
          <Route path="/about-us" element={<PageEditor pageTitle="About Us" initialContent="Welcome to LuxeFurniture..." />} />
          <Route path="/contact-us" element={<ContactCMS />} />
          <Route path="/privacy-policy" element={<PageEditor pageTitle="Privacy Policy" initialContent="Your privacy matters..." />} />
          <Route path="/terms-conditions" element={<PageEditor pageTitle="Terms & Conditions" initialContent="By using this site..." />} />
          
          <Route path="/settings" element={<Dashboard />} />
        </Routes>
      </div>
    )
}